import validator from 'validator';
import { z } from 'zod';
export const ALPHABET_ONLY_REGEX = /^[A-Za-z ]+$/i;
export const waitingListSchema = z.object({
    firstName: z
        .string({ required_error: 'First Name is a required field' })
        .regex(ALPHABET_ONLY_REGEX, {
        message: 'First Name must contain alphabets only',
    }),
    lastName: z
        .string({ required_error: 'Last Name is a required field' })
        .regex(ALPHABET_ONLY_REGEX, {
        message: 'Last Name must contain alphabets only',
    }),
    email: z.string({ required_error: 'Email is a required field' }).email(),
    phone: z
        .string({ required_error: 'Phone is a required field' })
        .refine((val) => !!val && validator.isMobilePhone(val, 'en-AU'), {
        message: 'Phone Number is invalid',
    }),
    sexPreference: z.string({
        required_error: 'Sex Preference is a required field',
    }),
    colorPreference: z
        .array(z.object({ value: z.string() }))
        .min(1, 'Color Preference is a required field'),
    type: z.string({ required_error: 'You are is a required field' }),
    ranking: z.number().min(0, 'Ranking has to be greater than 0').nullable().optional(),
    comment: z.string().optional(),
    isEdit: z.boolean().optional(),
});
export const contactSchema = z.object({
    name: z
        .string({
        required_error: 'Name is a required field',
    })
        .regex(ALPHABET_ONLY_REGEX, {
        message: 'Name must contain alphabets only',
    }),
    email: z
        .string({ required_error: 'Email is a required field' })
        .email('Please enter a valid email'),
    message: z.string({
        required_error: 'Message is a required field',
    }),
});
export const dogFormSchema = z.object({
    name: z.string({ required_error: 'Name is a required field' }),
    longName: z.string().optional(),
    ownedBy: z.string().optional(),
    dateOfBirth: z.date({
        required_error: 'Date Of Birth is a required field',
        invalid_type_error: 'Date Of Birth is a required field',
    }),
    dam: z.string().optional(),
    sire: z.string().optional(),
    color: z.string().optional(),
    sex: z.string({ required_error: 'Sex is a required field' }),
    hips: z.string().optional(),
    elbows: z.string().optional(),
    pra: z.string().optional(),
    eic: z.string().optional(),
    hpnk: z.string().optional(),
    category: z.string({ required_error: 'Category is a required field' }),
    content: z.string().optional(),
    coverImgUrl: z.string({ required_error: 'Cover Image is a required field' }),
    hipAndElbowUrl: z.string().optional(),
    dnaUrl: z.string().optional(),
    pedigreeUrl: z.string().optional(),
    cardiacUrl: z.string().optional(),
    eyeClearanceUrl: z.string().optional(),
    images: z.array(z.any()).min(1, 'At least 1 image must be uploaded'),
});
export const upcomingLitterFormSchema = z.object({
    name: z.string({ required_error: 'Name is a required field' }),
    sire: z
        .object({})
        .passthrough()
        .refine((val) => Object.keys(val).length > 0, {
        message: 'Sire is a required field',
    }),
    dam: z
        .object({})
        .passthrough()
        .refine((val) => Object.keys(val).length > 0, {
        message: 'Dam is a required field',
    }),
    limitedRegistrationPrice: z.number({
        required_error: 'Limited Registration Price is a required field',
        invalid_type_error: 'Limited Registration Price is a required field',
    }),
    mainRegistrationPrice: z.number({
        required_error: 'Main registration price is a required field',
        invalid_type_error: 'Main Registration Price is a required field',
    }),
    content: z.string().optional(),
    expectedColors: z
        .array(z.object({ value: z.string() }))
        .min(1, 'Color Preference is a required field'),
    expectedDueDate: z.date({
        required_error: 'Expected Due Date is a required field',
        invalid_type_error: 'Expected Due Date is a required field',
    }),
    expectedPuppyDate: z.date({
        required_error: 'Expected Puppy Date is a required field',
        invalid_type_error: 'Expected Puppy Date is a required field',
    }),
});
export const plannedLitterFormSchema = z.object({
    name: z.string({ required_error: 'Name is a required field' }),
    expectedColors: z
        .array(z.object({ value: z.string() }))
        .min(1, 'Color Preference is a required field'),
    expectedMatingDate: z.string({
        required_error: 'Expected Mating Date is a required field',
    }),
    expectedDueMonth: z.string({
        required_error: 'Expected Due Date is a required field',
    }),
    sire: z
        .object({})
        .passthrough()
        .refine((val) => Object.keys(val).length > 0, {
        message: 'Sire is a required field',
    }),
    dam: z
        .object({})
        .passthrough()
        .refine((val) => Object.keys(val).length > 0, {
        message: 'Dam is a required field',
    }),
    limitedRegistrationPrice: z.number({
        required_error: 'Limited Registration Price is a required field',
        invalid_type_error: 'Limited Registration Price is a required field',
    }),
    mainRegistrationPrice: z.number({
        required_error: 'Main registration price is a required field',
        invalid_type_error: 'Main Registration Price is a required field',
    }),
    content: z.string().optional(),
});
export const pastLitterFormSchema = z.object({
    name: z.string({ required_error: 'Name is a required field' }),
    sire: z
        .object({})
        .passthrough()
        .refine((val) => Object.keys(val).length > 0, {
        message: 'Sire is a required field',
    }),
    dam: z
        .object({})
        .passthrough()
        .refine((val) => Object.keys(val).length > 0, {
        message: 'Dam is a required field',
    }),
    dobOfPuppies: z.date({
        required_error: 'DOB of Puppies is a required field',
        invalid_type_error: 'DOB of Puppies is a required field',
    }),
    images: z.array(z.any()).min(1, 'At least 1 image must be uploaded'),
});
